import { useCallback } from 'react';

import * as events from 'utils/events';

/**
 * custom hook handler to call method parameter event when the user pressed the keyboard "tab" key
 * @param onTab event to trigger upon successful tab key press
 */
export default function useKeyboardTab(onTab: (e: React.KeyboardEvent) => void) {
  return useCallback((e: React.KeyboardEvent) => events.onTabClick(onTab)(e), [onTab]);
}
